(function ($) {
  const dataObj = {}

  var map
  window.initMap = function () {
    var grayStyle = [
      {
        'featureType': 'administrative',
        'elementType': 'all',
        'stylers': [
          {
            'saturation': '-100'
          }
        ]
      }, {
        'featureType': 'administrative.province',
        'elementType': 'all',
        'stylers': [
          {
            'visibility': 'off'
          }
        ]
      }, {
        'featureType': 'landscape',
        'elementType': 'all',
        'stylers': [
          {
            'saturation': -100
          }, {
            'lightness': 65
          }, {
            'visibility': 'on'
          }
        ]
      }, {
        'featureType': 'poi',
        'elementType': 'all',
        'stylers': [
          {
            'saturation': -100
          }, {
            'lightness': '50'
          }, {
            'visibility': 'simplified'
          }
        ]
      }, {
        'featureType': 'road',
        'elementType': 'all',
        'stylers': [
          {
            'saturation': '-100'
          }
        ]
      }, {
        'featureType': 'road.highway',
        'elementType': 'all',
        'stylers': [
          {
            'visibility': 'simplified'
          }
        ]
      }, {
        'featureType': 'road.arterial',
        'elementType': 'all',
        'stylers': [
          {
            'lightness': '30'
          }
        ]
      }, {
        'featureType': 'road.local',
        'elementType': 'all',
        'stylers': [
          {
            'lightness': '40'
          }
        ]
      }, {
        'featureType': 'transit',
        'elementType': 'all',
        'stylers': [
          {
            'saturation': -100
          }, {
            'visibility': 'simplified'
          }
        ]
      }, {
        'featureType': 'water',
        'elementType': 'geometry',
        'stylers': [
          {
            'hue': '#ffff00'
          }, {
            'lightness': -25
          }, {
            'saturation': -97
          }
        ]
      }, {
        'featureType': 'water',
        'elementType': 'labels',
        'stylers': [
          {
            'lightness': -25
          }, {
            'saturation': -100
          }
        ]
      }
    ]
    $.getJSON('/assets/data/map-data.json', function (data) {
      dataObj.jsonData = data

      var icon = '/assets/img/marker.png'
      var iconbase = '/assets/img/'
      var marker = []
      const commun = data.communities
      commun.forEach(function (e, i) {
        marker[i] = new google.maps.Marker({
          position: commun[i].coord,
          map: map,
          title: commun[i].address + ', ' + commun[i].city,
          icon: iconbase + commun[i].icon,
          group: commun[i].group,
          id: commun[i].slug,
          index: i
        })
      //  var val = marker[i].get("id");
        //console.log(val);
      })
      console.log('markers: ', marker[0].id)
    
      if ($('#communities-map').length) {
        // var CTO = {
        //   lat: 41.3186962,
        //   lng: -72.8726785
        // };
        var CTO = {
          lat: 41.447686,
          lng: -73.18186600000001
        }
        map = new google.maps.Map(document.getElementById('communities-map'), {
          center: CTO,
          zoom: 9,
          styles: grayStyle
        })
        var infowindow = new google.maps.InfoWindow({
          //content: contentString[i]
        })
        marker.forEach(function (e, i) {
          e.setMap(map)
          var contentString = []
          //var infoWindow = []
          contentString[i] = `<a href="./${commun[i].slug}"><img class="tooltip__thumb" src="${commun[i].thumbnail}" /></a>` + '<div id="content">' + '<div id="siteNotice">' + '</div>' + `<a href="./${commun[i].slug}"><h3 id="firstHeading" class="community__name">${commun[i].title}</h3></a>` + '<div id="bodyContent">' + `<p>${commun[i].address}<br />${commun[i].city} ${commun[i].zip}<br /><a href="tel:${commun[i].phone}">${commun[i].phone}</a></p>` + '</div>' + '</div>'

          google.maps.event.addListener(marker[i], 'mouseover', function () {
            infowindow.close()
            infowindow.setContent(contentString[i])
            infowindow.open(map, this)
          })
          // Zoom on Marker Click
          google.maps.event.addListener(marker[i], 'click', function () {

              map.panTo(this.getPosition())
              map.setZoom(15)

          })
          google.maps.event.addListener(map, 'click', function () {
            infowindow.close()
          })
        })
        
        //marker-link mouseover code

      };
    })
  }
})(jQuery)


// WEBPACK FOOTER //
// ./src/assets/js/map.js